import { __extends, __rest, __assign } from 'tslib';
import * as React from 'react';
import { UitkInput } from 'uitk-react-input';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-typeahead.css';

var getClassNameList = classNames.bind(styles);
var UitkTypeaheadInput = /** @class */ (function (_super) {
    __extends(UitkTypeaheadInput, _super);
    function UitkTypeaheadInput() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UitkTypeaheadInput.prototype.render = function () {
        var _a = this.props, className = _a.className, placeholder = _a.placeholder, required = _a.required, props = __rest(_a, ["className", "placeholder", "required"]);
        var cssClassNames = getClassNameList('uitk-typeahead-input', className);
        return (React.createElement(UitkInput, __assign({}, props, { autoCapitalize: "off", autoComplete: "off", autoCorrect: "off", className: cssClassNames, type: "text", spellCheck: false, placeholder: placeholder, required: required })));
    };
    UitkTypeaheadInput.displayName = 'UitkTypeaheadInput';
    return UitkTypeaheadInput;
}(React.Component));

export { UitkTypeaheadInput };
